import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { createCmdFactory } from '@cevi/rxjscommands';
import { merge, Observable, of, Subject } from 'rxjs';
import { map, switchMap, withLatestFrom, delay, shareReplay } from 'rxjs/operators';
import { AppService, DocumentAction } from '../../shared/app.service';
import { IPrikbordItem, PrikbordService } from '../prikbord.service';
import { IGenericDocument } from 'src/app/document-viewer/document-viewer.component';
import * as PDFOBject from 'pdfobject';
import { MenuService } from 'src/app/shared/menu.service';
import { DocumentViewerComponent } from '../../document-viewer/document-viewer.component';
import { NgIf, NgFor, AsyncPipe, DatePipe } from '@angular/common';

interface IPrikbordVm {
  informatief: IPrikbordItem[];
  extern: IPrikbordItem[];
  currentItem: IPrikbordItem;
  documentdata?: IGenericDocument;
  documentViewVisible?: boolean;
}

@Component({
    selector: 'app-prikbord-overzicht',
    templateUrl: './prikbord-overzicht.component.html',
    styleUrls: ['./prikbord-overzicht.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor, DocumentViewerComponent, AsyncPipe, DatePipe],
    providers:[PrikbordService]
})
export class PrikbordOverzichtComponent implements OnInit {

  public vm$: Observable<IPrikbordVm>;
  public vm: IPrikbordVm;

  constructor(
    private prikbordService: PrikbordService,
    private domSanitizer: DomSanitizer,
    private menuService: MenuService,
    private appService: AppService) {

    const cmdFactory = createCmdFactory<IPrikbordVm>();
    cmdFactory.addMapAction(this.viewDataAction$, 'viewData');
    cmdFactory.addMapAction(this.prikbordDetailAction$, 'prikbordDetail');
    cmdFactory.addMapAction(this.closeDetailAction$, 'closeDetail');
    this.vm$ = cmdFactory.merge({
      informatief: [],
      extern: [],
      currentItem: null
    });

  }

  private viewDataAction$ = merge(of(true), this.appService.refresh$).pipe(
    switchMap(_ => this.prikbordService.getPrikbordItems()),
    map(prikbordItems => (vm: IPrikbordVm) => ({
      ...vm,
      informatief: prikbordItems.filter(p => p.Soort === 'INFO'),
      extern: prikbordItems.filter(p => p.Soort === 'EXTERN')
    })),
    shareReplay({ refCount: true, bufferSize: 1 })

  );

  public prikbordDetailSubj = new Subject<IPrikbordItem>();
  private prikbordDetailAction$ = this.prikbordDetailSubj.pipe(
    switchMap(item => this.prikbordService.getPrikbordItemContent(item.Id)),
    withLatestFrom(this.prikbordDetailSubj),
    map(([result, item]) => (vm: IPrikbordVm) => {
      const currentItem = { ...item, Content: result };
      return { ...vm, currentItem, ...this.getDocumentData(currentItem) };
    })
  );
  public closeDetailSubj = new Subject<boolean>();
  private closeDetailAction$ = this.closeDetailSubj.pipe(
    map(_ => (vm: IPrikbordVm) => ({ ...vm, currentItem: null }))
  );

  getPrikbordItemId = (_: number, item: IPrikbordItem) => item.Id;

  ngOnInit() {
  }

  openExterneUrl(item: IPrikbordItem) {
    window.open(item.Url, '_blank');
    return false;
  }

  frameUrl = (currentItem: IPrikbordItem) => {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.prikbordService.getPrikbordBijlageUrl(currentItem.Id));
  }

  private getDocumentData(currentItem: IPrikbordItem) {
    const src = this.prikbordService.getPrikbordBijlageUrl(currentItem.Id);
    const ispdf = (currentItem.Ext || '').toLowerCase() === '.pdf';
    const documentdata: IGenericDocument = {
      title: '', // currentItem.BijlageTitel,
      src,
      ispdf, useinline:
        this.menuService.appGlobalData.PdfUseInlinePdfViewer
    };
    const downloadFile = this.appService.currentDocumentMode.id === DocumentAction.Download;
    const pdfInNewTab = (!PDFOBject.supportsPDFs) && (!documentdata.useinline) && (documentdata.ispdf);
    if (downloadFile || pdfInNewTab) {
      window.open(documentdata.src);
      return { documentViewVisible: false };
    }
    return { documentViewVisible: true, documentdata };
  }

  public showPrikbordDetail = (item:IPrikbordItem)=> {
    this.prikbordDetailSubj.next(item);
    return false;
  }

  public closeDetail=()=>{
    this.closeDetailSubj.next(true);
    return false;
  }

}
